<script>
import { Bar } from "vue-chartjs";
import ColorGenerator from "@/mixins/ColorGenerator/ColorGenerator";

export default {
    name: "BarChart",
    extends: Bar,
    mixins: [ColorGenerator],
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },
        height: {
            type: [Number, String],
            default: 300
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        var localChartdata = this.chartdata;
        if (this.reverse) {
            localChartdata.labels.reverse();
            localChartdata.datasets.map(dataset => {
                dataset.data.reverse();
            });
        }
        localChartdata.datasets = localChartdata.datasets.map(dataset => {
            if (!dataset.backgroundColor) {
                dataset.backgroundColor = this.generateColorPalette(
                    dataset.data.length
                );
            }
            return dataset;
        });
        this.renderChart(localChartdata, this.options);
    }
};
</script>
